import { Observable } from 'rxjs';
import { SpendType } from './model';

export abstract class SpendTypeRepository {
  abstract createSpendType(spendType: Partial<SpendType>, companyId?: string | number): Observable<SpendType>;
  abstract getSpendType(id: number): Observable<SpendType>;
  abstract getSpendTypes(page: number, limit: number): Observable<SpendType[]>;
  abstract updateSpendType(id: number, spendType: Partial<SpendType>): Observable<SpendType>;
  abstract deleteSpendType(id: number): Observable<void>;
  abstract matchSpendTypes(items: Array<{ description: string }>): Observable<any>;
}
